import get from 'lodash.get';

const getCurrentPackageSiteLimit = (rootState) =>
  get(rootState, 'subscriptions.currentPackage.features.siteCount', null);

export default getCurrentPackageSiteLimit;
